registerComponent("blocks/card-video", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Um clique em qualquer ponto do card dá play no `<iframe>` do YouTube. Em 2020
 * isso era `new YT.Player(iframe)` criado no `youtube.ready` — a IFrame API,
 * ~769 KiB, que o `legacy-main.js` baixava em TODA página — e
 * `player.playVideo()` no clique. A API só servia de intermediária para um
 * `postMessage`, e é o que vai aqui, direto: o embed já tem `enablejsapi=1` no
 * `src` (Blade) e aceita o comando `playVideo` de quem o hospeda. Zero bytes de
 * YouTube antes do clique, além do próprio embed que o Blade já emitia.
 *
 * O `console.log(player)` de 2020 saiu: era resto de depuração.
 *
 * Sem call site (ver read.md): coberto pelo render do
 * `UnreferencedComponentsTest` e pelo teste de navegador do relatório do 5d.
 */

const iframe = component.querySelector('iframe');

component.addEventListener('click', function () {
    if (!iframe || !iframe.contentWindow) {
        return;
    }

    let origem;

    try {
        origem = new URL(iframe.src, document.baseURI).origin;
    } catch (e) {
        return;
    }

    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), origem);
});

});
